import Settings from '../../../../settings/Settings';
import { $playerProfile } from '../../../../backend/store/playerProfile';
import { TopUpVFX } from '../../vfx/topup/TopUpVFX';

const LABEL = {
    FONT: Settings.FONTS.LEAGUE_SPARTAN,
    SIZE: 50,
    TINT: 0xffffff,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
    X: 180,
    OFFSET_Y: -3,
};

export default class Gold extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;
    private vfx!: TopUpVFX;

    public static globalPositionOfIcon: { x: number, y: number } = { x: 0, y: 0 }

    constructor(scene: Phaser.Scene) {
        let x = 50;
        let y = 220;
        super(scene, x, y);

        this.setupBG();
        this.setupIcon();
        this.setupLabel();
        this.setupVFX();
        this.setupListeners();
    }

    setupVFX() {
        console.log({ x: this.x, y: this.y })
        this.vfx = new TopUpVFX(this.scene, 10, 'gui/gold/icon', { x: this.x - 100, y: this.y }, { min: 50, max: 150 })
        this.scene.add.existing(this.vfx)
    }

    vfxShow(startPoint: { x: number; y: number; }) {
        // console.log(startPoint)
        this.vfx.showTime(startPoint)
    }

    setupBG() {
        let frame = 'gui/gold/bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setOrigin(0, 0.5);
        this.add(this.bg);
    }

    setupIcon() {
        let frame = 'gui/gold/icon';

        this.icon = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.icon);

        Gold.globalPositionOfIcon = { x: this.icon.getWorldTransformMatrix().tx, y: this.icon.getWorldTransformMatrix().ty }
    }

    setupLabel() {
        let x = LABEL.X;
        let y = LABEL.OFFSET_Y;

        let gold = String($playerProfile.getState().player_wallet.currency_soft);

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, gold, LABEL.SIZE);
        this.label.setOrigin(1, 0.5);
        this.label.setTint(LABEL.TINT);
        this.label.setDropShadow(LABEL.SHADOW.X, LABEL.SHADOW.Y, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }

    setupListeners() {
        $playerProfile.watch((state) => this.update(String(state.player_wallet.currency_soft)));
        this.scene.events.on('top_up_gold', this.vfxShow, this)
    }

    update(val: string) {
        this.label.setText(val);
    }

    destroy() {
        // this.scene.events.off(Session.EVENTS.GOLD_UPDATED, this.update, this);
    }
}
